import { render, staticRenderFns } from "./AddressBookAutocomplete.vue?vue&type=template&id=17bd0563&"
import script from "./AddressBookAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./AddressBookAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports